export class ZoneCodeConstants {
  public static readonly FISHMONGER: string = "040";
  public static readonly BUTCHERY: string = "181";
  public static readonly COLD_BUTCHERY: string = "178";
  public static readonly BAKERY: string = "129";
  public static readonly PASTRY: string = "128";
  public static readonly CHEESE: string = "090";
}

export class ProductionTypeConstants {
  public static readonly WILD: string = "Sauvage";
  public static readonly BREEDING: string = "Élevage";

}
